import { defineAsyncComponent } from "vue";
import { availabeRole } from "@/helpers/access";

export default {
  forms: {
    edit: {
      panel: {
        // height: '280px',
        width: "50%",
      },
      component: defineAsyncComponent(() => import("./forms/Edit.vue")),
    },
    list: {
      config: {
        sorting: true,
        actions: {
          edit: () =>
            availabeRole(["admin", "medical_doctor", "social_worker"]),
          create: () =>
            availabeRole(["admin", "medical_doctor", "social_worker"]),
          copy: () =>
            availabeRole(["admin", "medical_doctor", "social_worker"]),
          delete: () =>
            availabeRole(["admin", "medical_doctor", "social_worker"]),
        },
        fields: {
          id: {
            config: {
              visible: false,
            },
          },
          floor_name: {},
          name: {
            config: {
              sorting: "split_part(floor_rooms.name, '/', 1)::integer",
              sortingType: "roomNumber",
              label: "№ комнаты",
            },
          },
          area: {
            config: {
              sorting: "floor_rooms.area::numeric",
              sortingType: "number",
              label: "Площадь",
            },
          },
          block_id: {
            config: {
              label: "Блок",
            },
          },
          planned_places: {
            config: {
              sorting: "floor_rooms.planned_places::numeric",
              sortingType: "number",
              label: "Кол-во мест, план.",
            },
          },
          planned_deviation: {
            config: {
              label: "Плановое отклонение от нормы",
              sorting: "floor_rooms.planned_deviation::numeric",
              sortingType: "number",
              style: (row: any) => {
                const val = Number(row.planned_deviation);
                if (val > 0) return { color: "green", fontWeight: "bold" };
                if (val < 0) return { color: "red", fontWeight: "bold" };
                return {};
              },
            },
          },
          free_places: {
            config: {
              label: "Свободно",
              sorting: "floor_rooms.free_places::numeric",
              sortingType: "number",
            },
          },
          residents: {
            config: {
              label: "Заселено",
              sorting: "floor_rooms.residents::numeric",
              sortingType: "number",
            },
          },
        },
      },
    },
    select: {
      panel: {
        width: "80%",
      },
      config: {
        sorting: true,
        orderBy: {
          name: true,
        },
        actions: {
          edit: () =>
            availabeRole(["admin", "medical_doctor", "social_worker"]),
          create: () =>
            availabeRole(["admin", "medical_doctor", "social_worker"]),
          copy: () =>
            availabeRole(["admin", "medical_doctor", "social_worker"]),
          delete: () =>
            availabeRole(["admin", "medical_doctor", "social_worker"]),
        },
        subtable: true,
        fields: {
          id: {
            config: {
              visible: false,
            },
          },
          floor_name: {
            config: {
              sorting: "floor_rooms.floor_name",
            },
          },
          name: {
            config: {
              sorting: "split_part(floor_rooms.name, '/', 1)::integer",
              sortingType: "roomNumber",
              label: "№ комнаты",
            },
          },
          area: {
            config: {
              sorting: "floor_rooms.area::numeric",
              sortingType: "number",
              label: "Площадь",
            },
          },
          block_name: {
            config: {
              sorting: "floor_rooms.block_name",
              label: "Блок",
            },
          },
          planned_places: {
            config: {
              sorting: "floor_rooms.planned_places::numeric",
              sortingType: "number",
              label: "Кол-во мест, план.",
            },
          },
          planned_deviation: {
            config: {
              label: "Плановое отклонение от нормы",
              sorting: "floor_rooms.planned_deviation::numeric",
              sortingType: "number",
              style: (row: any) => {
                const val = Number(row.planned_deviation);
                if (val > 0) return { color: "green", fontWeight: "bold" };
                if (val < 0) return { color: "red", fontWeight: "bold" };
                return {};
              },
            },
          },
          free_places: {
            config: {
              label: "Свободно",
              sorting: "floor_rooms.free_places::numeric",
              sortingType: "number",
            },
          },
          residents: {
            config: {
              label: "Заселено",
              sorting: "floor_rooms.residents::numeric",
              sortingType: "number",
            },
          },
        },
      },
    },
  },
};
